import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import '../styles/carousel.css';

import { openCarousel } from './carouselDisplay'; 

const CarouselSwiper = ({ images }) => {
  return (
    <>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={5}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        loop={images.length > 1} // Loop only if more than one image
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[EffectCoverflow, Navigation, Pagination]}
        className="mySwiper"
      >
        {images.map((item, index) => (
          <SwiperSlide key={index}>
            <span className="img-text" onClick={() => openCarousel(images, index)}>
              <img src={item.url} alt={item.title} className="thumbnail" />
            </span>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default CarouselSwiper;
